import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const getLiveData = async (params) => {
  const { liveId } = params;
  const now = new Date();
  const res = await axios.middleware("/aluno.asmx/Listar_Lives", {
    params: {
      alunoid: _cookies.getItem("auth").user.alunoid,
      datetime: now.getDate(),
    },
  });

  return res[0].data.find((obj) => {
    return String(obj.liveid) === String(liveId);
  });
};

export const useLiveData = ({ config, liveId } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["live", { liveId }],
    queryFn: () => getLiveData({ liveId }),
  });
};
